import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import ToggleSwitch from '../../FormStyles/ToggleSwitch';
import TextInput from '../../FormStyles/TextInput';
import Hr from '../../Hr';

const DisclaimerText = ({
  handleChange,
  toggleName,
  textName,
  disclaimerText,
  showDisclaimerText,
  handleShowDisclaimer,
}) => {
  const { t } = useTranslation('tileForm');

  return (
    <DisclaimerTextWrapper>
      <ToggleSwitch
        label={t('disclaimerText.switchLabel')}
        value={showDisclaimerText}
        onChange={handleShowDisclaimer}
        name={toggleName}
        id={toggleName}
      />

      {showDisclaimerText && (
        <TextInput
          label={t('disclaimerText.inputLabel')}
          labelVariant="small1"
          charactersLimitVariant="small4"
          charactersLimitColor="black.60"
          as="textarea"
          name={textName}
          onChange={handleChange}
          value={disclaimerText || ''}
          placeholder={t('disclaimerText.inputPlaceholder')}
          m="10px 0"
        />
      )}
      <Separator />
    </DisclaimerTextWrapper>
  );
};

export default DisclaimerText;

DisclaimerText.propTypes = {
  handleChange: PropTypes.func,
  toggleName: PropTypes.string,
  textName: PropTypes.string,
  disclaimerText: PropTypes.string,
  showDisclaimerText: PropTypes.bool,
  handleShowDisclaimer: PropTypes.func,
};

const Separator = styled(Hr)`
  margin-top: 26px;
`;

const DisclaimerTextWrapper = styled.div`
  padding: 26px 0;
`;
